import { render, staticRenderFns } from "./highlights.vue?vue&type=template&id=6f60ee17&scoped=true"
import script from "./highlights.vue?vue&type=script&lang=js"
export * from "./highlights.vue?vue&type=script&lang=js"
import style0 from "./highlights.vue?vue&type=style&index=0&id=6f60ee17&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f60ee17",
  null
  
)

export default component.exports